/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Log } from '../../core/logging/Log';
import { ScreenControllerTypes } from '../../core/navigation/ScreenControllerTypes';
import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    onKeyBackAntiburnOsd,
    onKeyDigitAntiburnOsd,
    onKeyDownAntiburnOsd,
    onKeyGuideAntiburn,
    onKeyLeftAntiburnOsd,
    onKeyOkAntiburnOsd,
    onKeyRightAntiburnOsd,
    onKeyUpAntiburnOsd,
    onMouseClickAntiburnOsd,
    onMouseOverAntiburnOsd,
} from '../antiburnosd/antiburnosd.reducers';
import { onKeyColorBlueCollectionScreen } from '../collectionscreen/collectionscreen.reducers';
import {
    onKeyBackCollectionScreen,
    onKeyChannelDownCollectionScreen,
    onKeyChannelUpCollectionScreen,
    onKeyDigitCollectionScreen,
    onKeyDownCollectionScreen,
    onKeyInfoCollectionScreen,
    onKeyLeftCollectionScreen,
    onKeyOkCollectionScreen,
    onKeyRightCollectionScreen,
    onKeyUpCollectionScreen,
    onLongKeyOkCollectionScreen,
    onMouseClickCollectionScreen,
    onMouseOkLongPressStartCollectionScreen,
    onMouseOutCollectionScreen,
    onMouseOverCollectionScreen,
    onMouseWheelCollectionScreen,
} from '../collectionscreen/navigation/collectionscreennavigation.reducers';
import {
    onKeyOkErrorScreen,
    onKeyOkSos,
    onMouseClickError,
    onMouseOutErrorScreen,
    onMouseOverError,
} from '../error/error.reducers';
import {
    onKeyBackGallery,
    onKeyChannelDownGalleryScreen,
    onKeyChannelUpGalleryScreen,
    onKeyDigitGalleryView,
    onKeyDownGallery,
    onKeyInfoGalleryScreen,
    onKeyLeftGallery,
    onKeyOKGallery,
    onKeyPlayGallery,
    onKeyRightGallery,
    onKeyUpGallery,
    onLongKeyOkGalleryScreen,
    onMouseClickGallery,
    onMouseOkLongPressStartGalleryScreen,
    onMouseOutGallery,
    onMouseOverGallery,
} from '../galleryscreen/galleryscreen.reducers';
import {
    onKeyBackEmptyGuide,
    onKeyDownEmptyGuide,
    onKeyLeftEmptyGuide,
    onKeyOkEmptyGuide,
    onKeyRightEmptyGuide,
    onKeyUpEmptyGuide,
    onLongKeyOkEmptyGuide,
    onMouseClickEmptyGuide,
    onMouseOutEmptyGuide,
    onMouseOverEmptyGuide,
} from '../guide/emptyguide/emptyguide.navigation.reducers';
import {
    onKeyBackEmptyFilteredGuide,
    onKeyDownEmptyFilteredGuide,
    onKeyLeftEmptyFilteredGuide,
    onKeyOkEmptyFilteredGuide,
    onKeyRightEmptyFilteredGuide,
    onKeyUpEmptyFilteredGuide,
    onLongKeyOkEmptyFilteredGuide,
    onMouseClickEmptyFilteredGuide,
    onMouseOutEmptyFilteredGuide,
    onMouseOverEmptyFilteredGuide,
} from '../guide/filteredguide/emptyfilteredguide.navigation.reducers';
import {
    onKeyBackFilteredGuide,
    onKeyDigitFilteredGuide,
    onKeyDownFilteredGuide,
    onKeyGuideFilteredGuide,
    onKeyInfoFilteredGuide,
    onKeyLeftFilteredGuide,
    onKeyOkFilteredGuide,
    onKeyRightFilteredGuide,
    onKeyUpFilteredGuide,
    onLongKeyChannelDownFilteredGuide,
    onLongKeyChannelUpFilteredGuide,
    onLongKeyDownFilteredGuide,
    onLongKeyOkFilteredGuide,
    onLongKeyStopFilteredGuide,
    onLongKeyUpFilteredGuide,
} from '../guide/filteredguide/navigation/keyboard.navigation.reducers';
import {
    onMouseClickFilteredGuide,
    onMouseClickLongPressStartFilteredGuide,
    onMouseClickLongPressStopFilteredGuide,
    onMouseOutFilteredGuide,
    onMouseOverFilteredGuide,
    onMouseWheelFilteredGuide,
} from '../guide/filteredguide/navigation/mouse.navigation.reducers';
import {
    onKeyBackGuide,
    onKeyChannelDownGuide,
    onKeyChannelUpGuide,
    onKeyColorBlueGuide,
    onKeyDashGuide,
    onKeyDigitGuide,
    onKeyDownGuide,
    onKeyInfoGuide,
    onKeyLeftGuide,
    onKeyOkGuide,
    onKeyPlayGuide,
    onKeyPlayPauseGuide,
    onKeyRightGuide,
    onKeyUpGuide,
    onLongKeyChannelDownStartGuide,
    onLongKeyChannelUpStartGuide,
    onLongKeyDownStartGuide,
    onLongKeyOkGuide,
    onLongKeyUpStartGuide,
    onMouseClickGuide,
    onMouseOkLongPressStartGuide,
    onMouseOkLongPressStopGuide,
    onMouseOutGuide,
    onMouseOverGuide,
    onMouseWheelGuide,
} from '../guide/guidenavigation/guidenavigation.reducers';
import { stopGuidePageScroll, stopTurboScroll } from '../guide/turboscroll/turboscroll.reducers';
import {
    onKeyBackGlobalInfoCard,
    onKeyDigitGlobalInfoCard,
    onKeyDownGlobalInfoCard,
    onKeyLeftGlobalInfoCard,
    onKeyOkGlobalInfoCard,
    onKeyRightGlobalInfoCard,
    onKeyUpGlobalInfoCard,
    onMouseClickGlobalInfoCard,
    onMouseOutGlobalInfoCard,
    onMouseOverGlobalInfoCard,
    onMouseWheelGlobalInfoCard,
} from '../infocard/infocardnavigation.reducers';
import {
    onKeyBackListView,
    onKeyDigitListView,
    onKeyDownListView,
    onKeyInfoListView,
    onKeyLeftListView,
    onKeyOkListView,
    onKeyPlayListView,
    onKeyRightListView,
    onKeyUpListView,
    onLongKeyOkListView,
    onMouseClickListView,
    onMouseOkLongPressStartListView,
    onMouseOutListView,
    onMouseOverListView,
    onMouseWheelListView,
} from '../listscreenview/listviewscreen.reducers';
import {
    onKeyBackMyShows,
    onKeyChannelDownMyShows,
    onKeyChannelUpMyShows,
    onKeyDigitMyShows,
    onKeyDownMyShows,
    onKeyInfoMyShows,
    onKeyLeftMyShows,
    onKeyOkMyShows,
    onKeyPlayMyShows,
    onKeyRightMyShows,
    onKeyUpMyShows,
    onLongKeyOkMyShows,
    onMouseClickMyShows,
    onMouseOkLongPressStartMyShows,
    onMouseOutMyShows,
    onMouseOverMyShows,
    onMouseWheelMyShows,
} from '../myshows/myshowsnavigation/myshowsnavigation.reducers';
import {
    onKeyBackProgramScreen,
    onKeyDigitProgramScreen,
    onKeyDownProgramScreen,
    onKeyInfoProgramScreen,
    onKeyLeftProgramScreen,
    onKeyOkProgramScreen,
    onKeyPlayProgramScreen,
    onKeyRightProgramScreen,
    onKeyUpProgramScreen,
    onLongKeyOkProgramScreen,
    onMouseClickProgramScreen,
    onMouseOkLongPressStartProgramScreen,
    onMouseOutProgramScreen,
    onMouseOverProgramScreen,
} from '../programscreen/navigation/programscreennavigation.reducers';
import { showPCHelpScreen, showPreviousScreen } from '../screens/screens.reducers';
import {
    onKeyBackAccount,
    onKeyDownAccount,
    onKeyGuideAccount,
    onKeyOkAccount,
    onKeyUpAccount,
    onMouseClickAccount,
    onMouseOutAccount,
    onMouseOverAccount,
} from '../settings/account/accountnavigation.reducers';
import {
    onKeyBackHelp,
    onKeyDownHelp,
    onKeyGuideHelp,
    onKeyOkHelp,
    onKeyUpHelp,
    onMouseClickHelp,
    onMouseOutHelp,
    onMouseOverHelp,
} from '../settings/help/help.reducers';
import {
    onKeyBackPcHelp,
    onKeyDownPcHelp,
    onKeyGuidePcHelp,
    onKeyOkPcHelp,
    onKeyUpPcHelp,
    onMouseClickPcHelp,
    onMouseOutPcHelp,
    onMouseOverPcHelp,
} from '../settings/help/pchelp/pchelp.reducers';
import {
    onKeyBackHideAdultContentSettings,
    onKeyDownHideAdultContentSettings,
    onKeyOkHideAdultContentSettings,
    onKeyUpHideAdultContentSettings,
    onMouseClickHideAdultContentSettings,
    onMouseOutHideAdultContentSettings,
    onMouseOverHideAdultContentSettings,
} from '../settings/hideadultcontent/hideadultcontentnavigation/hideadultcontentnavigation.reducers';
import {
    onKeyBackInfoScreen,
    onKeyGuideInfoScreen,
} from '../settings/info/infonavigation.reducers';
import {
    onKeyBackMainSettings,
    onKeyDigitMainSettings,
    onKeyDownMainSettings,
    onKeyGuideMainSettings,
    onKeyLeftMainSettigs,
    onKeyOkMainSettings,
    onKeyRightMainSettings,
    onKeyUpMainSettings,
    onMouseClickMainSettings,
    onMouseOutMainSettings,
    onMouseOverMainSettings,
} from '../settings/mainsettings/mainsettings.reducers';
import {
    onKeyBackManage,
    onKeyDownManage,
    onKeyGuideManage,
    onKeyOkManage,
    onKeyUpManage,
    onMouseClickManage,
    onMouseOutManage,
    onMouseOverManage,
} from '../settings/manage/manage.reducers';
import {
    onKeyBackOnePassManager,
    onKeyChannelDownOnePassManager,
    onKeyChannelUpOnePassManager,
    onKeyDigitOnePassManager,
    onKeyDownOnePassManager,
    onKeyGuideOnePassManager,
    onKeyLeftOnePassManager,
    onKeyOkOnePassManager,
    onKeyRightOnePassManager,
    onKeyUpOnePassManager,
    onMouseClickOnePassManager,
    onMouseOutOnePassManager,
    onMouseOverOnePassManager,
    onMouseWheelOnePassManager,
} from '../settings/onepassmanager/onepassmanager.reducers';
import {
    onKeyBackPCSettings,
    onKeyDigitPCSettings,
    onKeyDownPCSettings,
    onKeyLeftPCSettings,
    onKeyOkPCSettings,
    onKeyRightPCSettings,
    onKeyUpPCSettings,
    onMouseClickPCSettings,
    onMouseOutPCSettings,
    onMouseOverPCSettings,
} from '../settings/parentalcontrols/parentalcontrolsnavigation/parentalcontrolsnavigation.reducers';
import {
    onKeyBackSetRatingLimits,
    onKeyDownSetRatingLimits,
    onKeyLeftSetRatingLimits,
    onKeyRightSetRatingLimits,
    onKeyUpSetRatingLimits,
    onMouseClickSetRatingLimits,
    onMouseOutSetRatingLimits,
    onMouseOverSetRatingLimits,
} from '../settings/parentalcontrols/setratinglimits/setratinglimitsnavigation/setratinglimitsnavigation.reducers';
import {
    onKeyBackEmptyRecordingActivity,
    onKeyOkEmptyRecordingActivity,
} from '../settings/recordingactivity/navigation/emptyrecordingactivity.navigation.reducers';
import {
    onMouseClickRecordingActivity,
    onMouseOkLongPressRecordingActivity,
    onMouseOutRecordingActivity,
    onMouseOverRecordingActivity,
} from '../settings/recordingactivity/navigation/mouse.navigation.reducers';
import {
    onKeyBackRecordingActivity,
    onKeyChannelDownRecordingActivity,
    onKeyChannelUpRecordingActivity,
    onKeyDigitRecordingActivity,
    onKeyDownRecordingActivity,
    onKeyGuideRecordingActivity,
    onKeyInfoRecordingActivity,
    onKeyLeftRecordingActivity,
    onKeyOkRecordingActivity,
    onKeyRightRecordingActivity,
    onKeyUpRecordingActivity,
    onLongPressOkRecordingActivity,
    onMouseWheelRecordingActivity,
} from '../settings/recordingactivity/navigation/recordingactivity.navigation.reducers';
import {
    onKeyBackEmptyToDoList,
    onKeyOkEmptyToDoList,
} from '../settings/todolist/emptytodolist.navigation.reducers';
import {
    onMouseClickToDoList,
    onMouseOkLongPressToDoList,
    onMouseOutToDoList,
    onMouseOverToDoList,
} from '../settings/todolist/navigation/mouse.navigation.reducers';
import {
    onKeyBackToDoList,
    onKeyChannelDownToDoList,
    onKeyChannelUpToDoList,
    onKeyDigitToDoList,
    onKeyDownToDoList,
    onKeyGuideToDoList,
    onKeyInfoToDoList,
    onKeyLeftToDoList,
    onKeyOkToDoList,
    onKeyRightToDoList,
    onKeyUpToDoList,
    onMouseWheelToDoList,
} from '../settings/todolist/navigation/todolist.navigation.reducers';
import { onLongPressOkToDoList } from '../settings/todolist/todolist.reducers';
import {
    onKeyBackMyShowsOptionsMenu,
    onKeyDownMyShowsOptionsMenu,
    onKeyOkMyShowsOptionsMenu,
    onKeyUpMyShowsOptionsMenu,
    onMouseOutMyShowsOptions,
    onMouseOverMyShowsOptions,
} from '../settings/userpreferences/myshowsoptionsmenu/myshowsoptionsmenu.navigation';
import {
    onKeyBackOnepassAndRecordingsOptionsMenu,
    onKeyDownOnePassAndRecordingsOptions,
    onKeyLeftOnePassAndRecordingsOptions,
    onKeyRightOnePassAndRecordingsOptions,
    onKeyUpOnePassAndRecordingsOptions,
    onMouseClickOnePassAndRecordingOptions,
    onMouseOutOnePassAndRecordingsOptions,
    onMouseOverOnePassAndRecordingsOptions,
} from '../settings/userpreferences/onepassandrecordings/onepassandrecordings.navigation';
import {
    onKeyBackAutoplayNextEpisode,
    onKeyDownAutoplayNextEpisode,
    onKeyGuideAutoplayNextEpisode,
    onKeyOkAutoplayNextEpisode,
    onKeyUpAutoplayNextEpisode,
    onMouseClickAutoplayNextEpisode,
    onMouseOutAutoplayNextEpisode,
    onMouseOverAutoplayNextEpisode,
} from '../settings/userpreferences/userprefautoplaynextepisode/userprefautoplaynextepisode.reducers';
import {
    onKeyBackUserPreferences,
    onKeyDownUserPreferences,
    onKeyGuideUserPreferences,
    onKeyOkUserPreferences,
    onKeyUpUserPreferences,
    onMouseClickUserPreferences,
    onMouseOutUserPreferences,
    onMouseOverUserPreferences,
} from '../settings/userpreferences/userpreferences.reducers';
import {
    onKeyBackMenuLanguage,
    onKeyDownMenuLanguage,
    onKeyGuideMenuLanguage,
    onKeyOkMenuLanguage,
    onKeyUpMenuLanguage,
    onMouseClickMenuLanguage,
    onMouseOutMenuLanguage,
    onMouseOverMenuLanguage,
} from '../settings/userpreferences/userprefmenulanguage/userprefmenulanguage.reducers';
import {
    onKeyBackUserPrefVideoWindowOperations,
    onKeyGuideUserPrefVideoWindowOperations,
    onKeyLeftUserPrefVideoWindowOperations,
    onKeyOkUserPrefVideoWindowOperations,
    onKeyRightUserPrefVideoWindowOperations,
    onMouseClickInteractiveLayerOperations,
    onMouseOutUserPrefVideoWindowOperations,
    onMouseOverUserPrefVideoWindowOperations,
} from '../settings/userpreferences/userprefvideowindow/userprefvideowindow.reducers';
import {
    onKeyBackSidebarNavigationMenu,
    onKeyDownSidebarNavigationMenu,
    onKeyOkSidebarNavigationMenu,
    onKeyRightSidebarNavigationMenu,
    onKeyUpSidebarNavigationMenu,
    onMouseClickSidebarNavigationMenu,
    onMouseOutSidebarNavigationMenu,
    onMouseOverSidebarNavigationMenu,
} from '../sidebarnavigationmenu/sidebarmenunavigation/sidebarmenunavigation.reducers';
import {
    onKeyBackSignIn,
    onKeyDownSignIn,
    onKeyOkSignIn,
    onKeyUpSignIn,
    onMouseClickSignIn,
    onMouseOutSignIn,
    onMouseOverSignIn,
} from '../signin/signinnavigation.reducers';
import { onKeyOkSplashScreen } from '../splashscreen/splashscreen.reducers';
import {
    clearLongPressIntervalVideoPlayerUi,
    onKeyAdvanceVideoPlayerUi,
    onKeyBackVideoPlayerUi,
    onKeyChannelDownVideoPlayerUi,
    onKeyChannelUpVideoPlayerUi,
    onKeyDigitVideoPlayerUi,
    onKeyDownVideoPlayerUi,
    onKeyExitVideoPlayerUi,
    onKeyFastForwardVideoPlayerUi,
    onKeyGuideVideoPlayerUi,
    onKeyInfoVideoPlayerUi,
    onKeyLeftVideoPlayerUi,
    onKeyLongLeftVideoPlayerUi,
    onKeyLongRightVideoPlayerUi,
    onKeyOkVideoPlayerUi,
    onKeyPauseVideoPlayerUi,
    onKeyPlayPauseVideoPlayerUi,
    onKeyPlayVideoPlayerUi,
    onKeyReplayVideoPlayerUi,
    onKeyRewindVideoPlayerUi,
    onKeyRightVideoPlayerUi,
    onKeyStopVideoPlayerUi,
    onKeyTivoVideoPlayerUi,
    onKeyUpVideoPlayerUi,
    onLongKeyChannelDownStartVideoPlayerUi,
    onLongKeyChannelUpStartVideoPlayerUi,
    onLongKeyDownVideoPlayerUi,
    onLongKeyOkVideoPlayerUi,
    onLongKeyStopVideoPlayerUi,
    onLongKeyUpVideoPlayerUi,
    onMouseClickVideoPlayerUi,
    onMouseOkLongPressOneLineGuide,
    onMouseOkLongPressStopOneLineGuide,
    onMouseOutVideoPlayerUi,
    onMouseOverVideoPlayerUi,
    onMouseWheelVideoPlayerUi,
} from '../videoplayerui/videoplayeruinavigation.reducers';
import {
    onKeyBackVodBrowseMainScreen,
    onKeyChannelDownVodBrowseMainScreen,
    onKeyChannelUpVodBrowseMainScreen,
    onKeyDigitVodBrowseMainScreen,
    onKeyDownVodBrowseMainScreen,
    onKeyGuideVodBrowseMainScreen,
    onKeyInfoVodBrowseMainScreen,
    onKeyLeftVodBrowseMainScreen,
    onKeyLongChannelDownStartVodBrowseMainScreen,
    onKeyLongChannelDownStopVodBrowseMainScreen,
    onKeyLongChannelUpStartVodBrowseMainScreen,
    onKeyLongChannelUpStopVodBrowseMainScreen,
    onKeyLongDownStartVodBrowseMainScreen,
    onKeyLongDownStopVodBrowseMainScreen,
    onKeyLongLeftStartVodBrowseMainScreen,
    onKeyLongLeftStopVodBrowseMainScreen,
    onKeyLongOkVodBrowseMainScreen,
    onKeyLongRightStartVodBrowseMainScreen,
    onKeyLongRightStopVodBrowseMainScreen,
    onKeyLongUpStartVodBrowseMainScreen,
    onKeyLongUpStopVodBrowseMainScreen,
    onKeyOkVodBrowseMainScreen,
    onKeyPlayVodBrowseMainScreen,
    onKeyRightVodBrowseMainScreen,
    onKeyUpVodBrowseMainScreen,
    onMouseClickVodBrowseMainScreen,
    onMouseOkLongPressStartVodBrowseMainScreen,
    onMouseOkLongPressStopVodBrowseMainScreen,
    onMouseOutVodBrowseMainScreen,
    onMouseOverVodBrowseMainScreen,
} from '../vodbrowsemainscreen/navigation/vodbrowsemainscreennavigation.reducers';
import { CLEAR_KEY_EVENT, ON_KEY_EVENT, ON_MOUSE_EVENT } from './inputfactory.types';

const TAG = 'inputFactory';

const initialState: {
    key: string;
    code: number;
    identity: number;
    eventType: string;
    value: any;
} = {
    key: '',
    code: 0,
    identity: 0,
    eventType: '',
    value: undefined,
};

const inputFactoryReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<typeof initialState>>{},
) => {
    const id = state.identity + 1;
    switch (type) {
        case ON_KEY_EVENT:
            return { ...state, key: payload.key, code: payload.code, identity: id };
        case ON_MOUSE_EVENT:
            return {
                ...state,
                eventType: payload.eventType,
                value: payload.value,
                identity: id,
            };
        case CLEAR_KEY_EVENT:
            return {
                ...state,
                key: '',
                code: 0,
            };
        default:
            return state;
    }
};

export const onKeyRight = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onKeyRightGlobalInfoCard());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyRightAntiburnOsd());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyRightCollectionScreen());
            break;

        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onKeyRightEmptyGuide());
            break;

        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onKeyRightEmptyFilteredGuide());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyRightGallery());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyRightGuide());
            break;

        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onKeyRightPCSettings());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyRightVideoPlayerUi());
            break;

        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onKeyRightOnePassAndRecordingsOptions());
            break;

        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onKeyRightSetRatingLimits());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyRightListView());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyRightMyShows());
            break;

        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyRightMainSettings());
            break;

        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onKeyRightSidebarNavigationMenu());
            break;
        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyRightProgramScreen());
            break;

        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onKeyRightUserPrefVideoWindowOperations());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyRightOnePassManager());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyRightFilteredGuide());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyRightVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyRightToDoList());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyRightRecordingActivity());
            break;
        default:
    }
};

export const onLongRightStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyLongRightVideoPlayerUi());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongRightStartVodBrowseMainScreen());
            break;

        default:
    }
};

export const onLongRightStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(clearLongPressIntervalVideoPlayerUi());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongRightStopVodBrowseMainScreen());
            break;

        default:
    }
};

export const onKeyLeft = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onKeyLeftGlobalInfoCard());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyLeftAntiburnOsd());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyLeftCollectionScreen());
            break;

        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onKeyLeftEmptyGuide());
            break;

        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onKeyLeftEmptyFilteredGuide());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyLeftGallery());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyLeftGuide());
            break;

        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onKeyLeftPCSettings());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyLeftVideoPlayerUi());
            break;

        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onKeyLeftOnePassAndRecordingsOptions());
            break;

        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onKeyLeftSetRatingLimits());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyLeftListView());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyLeftMyShows());
            break;

        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyLeftMainSettigs());
            break;

        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyLeftProgramScreen());
            break;

        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onKeyLeftUserPrefVideoWindowOperations());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyLeftOnePassManager());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyLeftFilteredGuide());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLeftVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyLeftToDoList());
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyLeftRecordingActivity());
            break;
        default:
    }
};

export const onLongLeftStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyLongLeftVideoPlayerUi());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongLeftStartVodBrowseMainScreen());
            break;

        default:
    }
};

export const onLongLeftStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongRightStop());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongLeftStopVodBrowseMainScreen());
            break;

        default:
    }
};

export const onKeyUp = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onKeyUpGlobalInfoCard());
            break;

        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onKeyUpAccount());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyUpAntiburnOsd());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyUpCollectionScreen());
            break;

        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onKeyUpEmptyGuide());
            break;
        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onKeyUpEmptyFilteredGuide());
            break;

        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyUpGallery());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyUpGuide());
            break;

        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onKeyUpHelp());
            break;

        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onKeyUpPcHelp());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyUpVideoPlayerUi());
            break;

        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyUpMainSettings());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyUpListView());
            break;

        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyUpSignIn());
            break;

        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onKeyUpPCSettings());
            break;

        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyUpProgramScreen());
            break;

        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onKeyUpAutoplayNextEpisode());
            break;

        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onKeyUpMenuLanguage());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyUpMyShows());
            break;

        case ScreenControllerTypes.MY_SHOWS_OPTIONS_MENU_SCREEN:
            dispatch(onKeyUpMyShowsOptionsMenu());
            break;

        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onKeyUpOnePassAndRecordingsOptions());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyUpOnePassManager());
            break;

        case ScreenControllerTypes.PC_HIDE_ADULT_CONTENT_SCREEN:
            dispatch(onKeyUpHideAdultContentSettings());
            break;

        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onKeyUpSetRatingLimits());
            break;

        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onKeyUpSidebarNavigationMenu());
            break;

        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onKeyUpUserPreferences());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyUpFilteredGuide());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyUpVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onKeyUpManage());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyUpToDoList());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyUpRecordingActivity());
            break;

        default:
    }
};

export const onKeyDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onKeyDownGlobalInfoCard());
            break;

        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onKeyDownAccount());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyDownAntiburnOsd());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyDownCollectionScreen());
            break;

        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onKeyDownEmptyGuide());
            break;

        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onKeyDownEmptyFilteredGuide());
            break;

        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyDownGallery());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyDownGuide());
            break;

        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onKeyDownHelp());
            break;

        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onKeyDownPcHelp());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyDownVideoPlayerUi());
            break;

        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyDownMainSettings());
            break;

        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onKeyDownAutoplayNextEpisode());
            break;

        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onKeyDownMenuLanguage());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyDownListView());
            break;

        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyDownSignIn());
            break;

        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onKeyDownPCSettings());
            break;

        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyDownProgramScreen());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyDownMyShows());
            break;

        case ScreenControllerTypes.MY_SHOWS_OPTIONS_MENU_SCREEN:
            dispatch(onKeyDownMyShowsOptionsMenu());
            break;

        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onKeyDownOnePassAndRecordingsOptions());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyDownOnePassManager());
            break;

        case ScreenControllerTypes.PC_HIDE_ADULT_CONTENT_SCREEN:
            dispatch(onKeyDownHideAdultContentSettings());
            break;

        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onKeyDownSetRatingLimits());
            break;

        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onKeyDownSidebarNavigationMenu());
            break;

        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onKeyDownUserPreferences());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyDownFilteredGuide());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyDownVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onKeyDownManage());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyDownToDoList());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyDownRecordingActivity());
            break;
        default:
    }
};

export const onKeyOk = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onKeyOkGlobalInfoCard());
            break;

        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onKeyOkAccount());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyOkCollectionScreen());
            break;

        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onKeyOkEmptyGuide());
            break;

        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyOKGallery());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyOkGuide());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyOkFilteredGuide());
            break;

        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onKeyOkEmptyFilteredGuide());
            break;

        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onKeyOkHelp());
            break;

        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onKeyOkPcHelp());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyOkListView());
            break;

        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyOkMainSettings());
            break;

        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onKeyOkMenuLanguage());
            break;

        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyOkSignIn());
            break;

        case ScreenControllerTypes.SOS_SCREEN:
            dispatch(onKeyOkSos());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyOkVideoPlayerUi());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyOkAntiburnOsd());
            break;

        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onKeyOkErrorScreen());
            break;

        case ScreenControllerTypes.SPLASH_SCREEN:
            dispatch(onKeyOkSplashScreen());
            break;

        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onKeyOkPCSettings());
            break;

        case ScreenControllerTypes.PC_HIDE_ADULT_CONTENT_SCREEN:
            dispatch(onKeyOkHideAdultContentSettings());
            break;

        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyOkProgramScreen());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyOkMyShows());
            break;

        case ScreenControllerTypes.MY_SHOWS_OPTIONS_MENU_SCREEN:
            dispatch(onKeyOkMyShowsOptionsMenu());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyOkOnePassManager());
            break;

        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onKeyOkSidebarNavigationMenu());
            break;

        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onKeyOkUserPreferences());
            break;

        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onKeyOkAutoplayNextEpisode());
            break;

        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onKeyOkUserPrefVideoWindowOperations());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyOkVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onKeyOkManage());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyOkToDoList());
            break;

        case ScreenControllerTypes.EMPTY_TODO_LIST_SCREEN:
            dispatch(onKeyOkEmptyToDoList());
            break;

        case ScreenControllerTypes.EMPTY_RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyOkEmptyRecordingActivity());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyOkRecordingActivity());
            break;
        default:
    }
};

export const onLongOkStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onLongKeyOkEmptyGuide());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyOkGuide());
            break;
        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyOkEmptyFilteredGuide());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyOkFilteredGuide());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyOkVideoPlayerUi());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongOkVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onLongPressOkToDoList());
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onLongPressOkRecordingActivity());
            break;
        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onLongKeyOkMyShows());
            break;
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onLongKeyOkCollectionScreen());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onLongKeyOkGalleryScreen());
            break;
        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onLongKeyOkProgramScreen());
            break;
        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onLongKeyOkListView());
            break;
        default:
    }
};

export const onKeyChannelUp = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyChannelUpCollectionScreen());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyChannelUpGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyChannelUpVideoPlayerUi());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyChannelUpOnePassManager());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyChannelUpMyShows());
            break;

        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyChannelUpGalleryScreen());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyChannelUpVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyChannelUpToDoList());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyChannelUpRecordingActivity());
            break;

        default:
    }
};

export const onKeyChannelDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyChannelDownCollectionScreen());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyChannelDownGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyChannelDownVideoPlayerUi());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyChannelDownOnePassManager());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyChannelDownMyShows());
            break;

        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyChannelDownGalleryScreen());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyChannelDownVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyChannelDownToDoList());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyChannelDownRecordingActivity());
            break;

        default:
    }
};

export const onKeyExit = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    if (screenController === ScreenControllerTypes.VIDEO_PLAYER) {
        dispatch(onKeyExitVideoPlayerUi());
    }
};

export const onKeyGuide = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onKeyGuideAccount());
            break;

        case ScreenControllerTypes.GUIDE:
            Log.i(TAG, 'Already in guide screen');
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyGuideFilteredGuide());
            break;

        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onKeyGuideHelp());
            break;

        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onKeyGuidePcHelp());
            break;

        case ScreenControllerTypes.INFO_SCREEN:
            dispatch(onKeyGuideInfoScreen());
            break;

        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyGuideMainSettings());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyGuideOnePassManager());
            break;

        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onKeyGuideMenuLanguage());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyGuideVideoPlayerUi());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyGuideAntiburn());
            break;

        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onKeyGuideUserPreferences());
            break;

        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onKeyGuideAutoplayNextEpisode());
            break;

        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onKeyGuideUserPrefVideoWindowOperations());
            break;

        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onKeyGuideManage());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyGuideToDoList());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyGuideRecordingActivity());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyGuideVodBrowseMainScreen());
            break;

        default:
    }
};

export const onKeyInfo = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyInfoCollectionScreen());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyInfoGuide());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyInfoFilteredGuide());
            break;

        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyInfoProgramScreen());
            break;

        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyInfoGalleryScreen());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyInfoVideoPlayerUi());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyInfoVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyInfoToDoList());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyInfoMyShows());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyInfoRecordingActivity());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyInfoListView());
            break;

        default:
    }
};

export const onKeyTivo = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyTivoVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyDigit = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onKeyDigitGlobalInfoCard());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyDigitAntiburnOsd());
            break;
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyDigitCollectionScreen());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyDigitGuide());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyDigitGalleryView());
            break;
        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onKeyDigitPCSettings());
            break;
        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyDigitProgramScreen());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyDigitVideoPlayerUi());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyDigitFilteredGuide());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyDigitListView());
            break;
        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyDigitMyShows());
            break;
        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyDigitMainSettings());
            break;
        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyDigitOnePassManager());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyDigitVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyDigitToDoList());
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyDigitRecordingActivity());
            break;
        default:
    }
};

export const onKeyDash = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyDashGuide());
            break;
        default:
    }
};

export const onKeyBack = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onKeyBackGlobalInfoCard());
            break;

        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onKeyBackAccount());
            break;

        case ScreenControllerTypes.CLOUD_DVR_HELP_SCREEN:
            dispatch(showPreviousScreen());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyBackCollectionScreen());
            break;

        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onKeyBackEmptyGuide());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyBackFilteredGuide());
            break;

        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onKeyBackEmptyFilteredGuide());
            break;

        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyBackGallery());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyBackGuide());
            break;

        case ScreenControllerTypes.INFO_SCREEN:
            dispatch(onKeyBackInfoScreen());
            break;

        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onKeyBackHelp());
            break;

        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onKeyBackPcHelp());
            break;

        case ScreenControllerTypes.PC_HELP_SCREEN_OPTION:
            dispatch(showPCHelpScreen());
            break;

        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onKeyBackMainSettings());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyBackVideoPlayerUi());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onKeyBackAntiburnOsd());
            break;

        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onKeyBackSignIn());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyBackMyShows());
            break;

        case ScreenControllerTypes.MY_SHOWS_OPTIONS_MENU_SCREEN:
            dispatch(onKeyBackMyShowsOptionsMenu());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyBackListView());
            break;

        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyBackProgramScreen());
            break;

        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onKeyBackOnepassAndRecordingsOptionsMenu());
            break;

        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onKeyBackMenuLanguage());
            break;

        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onKeyBackOnePassManager());
            break;

        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onKeyBackPCSettings());
            break;

        case ScreenControllerTypes.PC_HIDE_ADULT_CONTENT_SCREEN:
            dispatch(onKeyBackHideAdultContentSettings());
            break;

        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onKeyBackSetRatingLimits());
            break;

        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onKeyBackSidebarNavigationMenu());
            break;

        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onKeyBackAutoplayNextEpisode());
            break;

        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onKeyBackUserPrefVideoWindowOperations());
            break;

        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onKeyBackUserPreferences());
            break;

        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onKeyBackManage());
            break;

        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onKeyBackToDoList());
            break;

        case ScreenControllerTypes.EMPTY_TODO_LIST_SCREEN:
            dispatch(onKeyBackEmptyToDoList());
            break;

        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyBackRecordingActivity());
            break;

        case ScreenControllerTypes.EMPTY_RECORDING_ACTIVITY_SCREEN:
            dispatch(onKeyBackEmptyRecordingActivity());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyBackVodBrowseMainScreen());
            break;

        default:
    }
};

export const onKeyPlay = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onKeyPlayGallery());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyPlayGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyPlayVideoPlayerUi());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyPlayMyShows());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyPlayVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onKeyOkFilteredGuide());
            break;

        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onKeyPlayListView());
            break;

        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onKeyPlayProgramScreen());
            break;

        default:
    }
};

export const onKeyStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyStopVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyFastForward = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyFastForwardVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyRewind = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyRewindVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyReplay = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyReplayVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyColorBlue = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyColorBlueGuide());
            break;

        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onKeyColorBlueGuide());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onKeyColorBlueCollectionScreen());
            break;

        default:
    }
};

export const onKeyAdvance = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyAdvanceVideoPlayerUi());
            break;

        default:
    }
};

export const onKeyPlayPause = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onKeyPlayPauseGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyPlayPauseVideoPlayerUi());
            break;

        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onKeyPlayMyShows());
            break;

        default:
    }
};

export const onKeyPause = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onKeyPauseVideoPlayerUi());
            break;

        default:
    }
};

export const onLongStartDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyDownStartGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyDownVideoPlayerUi());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongDownStartVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyDownFilteredGuide());
            break;

        default:
    }
    Log.i(TAG, 'onLongStartDown');
};

export const onLongStartUp = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyUpStartGuide());
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyUpVideoPlayerUi());
            break;

        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongUpStartVodBrowseMainScreen());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyUpFilteredGuide());
            break;

        default:
    }
    Log.i(TAG, 'onLongStartUp');
};

export const onLongStopDown = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(stopTurboScroll());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyStopVideoPlayerUi());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongDownStopVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyStopFilteredGuide());
            break;
        default:
    }
};

export const onLongStopUp = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    if (screenController === ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN) {
        dispatch(onKeyLongUpStopVodBrowseMainScreen());
    } else {
        dispatch(onLongStopDown());
    }
};

export const onLongChannelUpStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyChannelUpStartGuide());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyChannelUpStartVideoPlayerUi());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyChannelUpFilteredGuide());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongChannelUpStartVodBrowseMainScreen());
            break;

        default:
    }
    Log.i(TAG, 'onLongChannelUpStart');
};

export const onLongChannelDownStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onLongKeyChannelDownStartGuide());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyChannelDownStartVideoPlayerUi());
            break;

        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyChannelDownFilteredGuide());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongChannelDownStartVodBrowseMainScreen());
            break;

        default:
    }
    Log.i(TAG, 'onLongChanneldownStart');
};

export const onLongChannelUpStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(stopGuidePageScroll());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onLongKeyStopVideoPlayerUi());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onLongKeyStopFilteredGuide());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongChannelUpStopVodBrowseMainScreen());
            break;
        default:
    }
};

export const onLongChannelDownStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onKeyLongChannelDownStopVodBrowseMainScreen());
            break;
        default:
            dispatch(onLongChannelUpStop());
    }
};

export const onMouseClick = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onMouseClickGlobalInfoCard());
            break;

        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onMouseClickAccount());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onMouseClickAntiburnOsd());
            break;

        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onMouseClickCollectionScreen());
            break;
        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onMouseClickEmptyGuide());
            break;
        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onMouseClickEmptyFilteredGuide());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onMouseClickFilteredGuide());
            break;
        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onMouseClickError());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onMouseClickGallery());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseClickGuide());
            break;
        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onMouseClickHelp());
            break;
        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onMouseClickListView());
            break;
        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onMouseClickPcHelp());
            break;
        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onMouseClickMainSettings());
            break;
        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onMouseClickMyShows());
            break;
        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onMouseClickMenuLanguage());
            break;
        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onMouseClickOnePassManager());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onMouseClickSignIn());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseClickVideoPlayerUi());
            break;
        case ScreenControllerTypes.PC_HIDE_ADULT_CONTENT_SCREEN:
            dispatch(onMouseClickHideAdultContentSettings());
            break;
        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onMouseClickPCSettings());
            break;
        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onMouseClickSetRatingLimits());
            break;
        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onMouseClickSidebarNavigationMenu());
            break;
        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onMouseClickUserPreferences());
            break;
        case ScreenControllerTypes.MY_SHOWS_OPTIONS_MENU_SCREEN:
            dispatch(onKeyOkMyShowsOptionsMenu());
            break;
        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onMouseClickOnePassAndRecordingOptions());
            break;
        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onMouseClickAutoplayNextEpisode());
            break;
        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onMouseClickInteractiveLayerOperations());
            break;
        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onMouseClickProgramScreen());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onMouseClickVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onMouseClickManage());
            break;
        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onMouseClickToDoList());
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onMouseClickRecordingActivity());
            break;
        default:
    }
};

// eslint-disable-next-line no-unused-vars
export const onMouseEnter = () => (dispatch: Function, getState: Function) => {
    Log.i(TAG, 'onMouseEnter');
};

// eslint-disable-next-line no-unused-vars
export const onMouseLeave = () => (dispatch: Function, getState: Function) => {
    Log.i(TAG, 'onMouseLeave');
};

export const onMouseOkLongPressStart = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;
    Log.i(TAG, 'onMouseOkLongPressStart');

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOkLongPressStartGuide());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseOkLongPressOneLineGuide());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onMouseClickLongPressStartFilteredGuide());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onMouseOkLongPressStartVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onMouseOkLongPressToDoList());
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onMouseOkLongPressRecordingActivity());
            break;
        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onMouseOkLongPressStartMyShows());
            break;
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onMouseOkLongPressStartCollectionScreen());
            break;
        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onMouseOkLongPressStartProgramScreen());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onMouseOkLongPressStartGalleryScreen());
            break;
        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onMouseOkLongPressStartListView());
            break;
        default:
    }
};

export const onMouseOkLongPressStop = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOkLongPressStopGuide());
            Log.i(TAG, 'onMouseOkLongPressStop');
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseOkLongPressStopOneLineGuide());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onMouseOkLongPressStopVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onMouseClickLongPressStopFilteredGuide());
            break;
        default:
    }
};

export const onMouseOut = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onMouseOutGlobalInfoCard());
            break;

        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onMouseOutAccount());
            break;
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onMouseOutCollectionScreen());
            break;
        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onMouseOutEmptyGuide());
            break;
        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onMouseOutEmptyFilteredGuide());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onMouseOutFilteredGuide());
            break;
        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onMouseOutErrorScreen());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onMouseOutGallery());
            break;
        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOutGuide());
            break;
        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onMouseOutHelp());
            break;
        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onMouseOutPcHelp());
            break;
        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onMouseOutMainSettings());
            break;
        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onMouseOutMenuLanguage());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onMouseOutSignIn());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseOutVideoPlayerUi());
            break;
        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onMouseOutListView());
            break;
        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onMouseOutMyShows());
            break;
        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onMouseOutOnePassManager());
            break;
        case ScreenControllerTypes.PC_HIDE_ADULT_CONTENT_SCREEN:
            dispatch(onMouseOutHideAdultContentSettings());
            break;
        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onMouseOutPCSettings());
            break;
        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onMouseOutSetRatingLimits());
            break;
        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onMouseOutSidebarNavigationMenu());
            break;
        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onMouseOutUserPreferences());
            break;
        case ScreenControllerTypes.MY_SHOWS_OPTIONS_MENU_SCREEN:
            dispatch(onMouseOutMyShowsOptions());
            break;
        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onMouseOutOnePassAndRecordingsOptions());
            break;
        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onMouseOutAutoplayNextEpisode());
            break;
        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onMouseOutUserPrefVideoWindowOperations());
            break;
        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onMouseOutProgramScreen());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onMouseOutVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onMouseOutManage());
            break;
        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onMouseOutToDoList());
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onMouseOutRecordingActivity());
            break;
        default:
    }
};

export const onMouseOver = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onMouseOverGlobalInfoCard());
            break;

        case ScreenControllerTypes.ACCOUNT_SCREEN:
            dispatch(onMouseOverAccount());
            break;
        case ScreenControllerTypes.EMPTY_GUIDE_SCREEN:
            dispatch(onMouseOverEmptyGuide());
            break;
        case ScreenControllerTypes.EMPTY_FILTERED_GUIDE_SCREEN:
            dispatch(onMouseOverEmptyFilteredGuide());
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onMouseOverFilteredGuide());
            break;
        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(onMouseOverAntiburnOsd());
            break;
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onMouseOverCollectionScreen());
            break;
        case ScreenControllerTypes.ERROR_SCREEN:
            dispatch(onMouseOverError());
            break;
        case ScreenControllerTypes.GALLERY_SCREEN:
            dispatch(onMouseOverGallery());
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseOverGuide());
            break;
        case ScreenControllerTypes.HELP_SCREEN:
            dispatch(onMouseOverHelp());
            break;
        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onMouseOverListView());
            break;
        case ScreenControllerTypes.PC_HELP_SCREEN:
            dispatch(onMouseOverPcHelp());
            break;
        case ScreenControllerTypes.MAIN_SETTINGS_SCREEN:
            dispatch(onMouseOverMainSettings());
            break;
        case ScreenControllerTypes.MENU_LANGUAGE_SCREEN:
            dispatch(onMouseOverMenuLanguage());
            break;
        case ScreenControllerTypes.SIGN_IN_SCREEN:
            dispatch(onMouseOverSignIn());
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseOverVideoPlayerUi());
            break;
        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onMouseOverMyShows());
            break;
        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onMouseOverOnePassManager());
            break;
        case ScreenControllerTypes.PC_HIDE_ADULT_CONTENT_SCREEN:
            dispatch(onMouseOverHideAdultContentSettings());
            break;
        case ScreenControllerTypes.PC_SCREEN:
            dispatch(onMouseOverPCSettings());
            break;
        case ScreenControllerTypes.PC_SET_RATING_LIMITS_SCREEN:
            dispatch(onMouseOverSetRatingLimits());
            break;
        case ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN:
            dispatch(onMouseOverSidebarNavigationMenu());
            break;
        case ScreenControllerTypes.USER_PREFERENCES_SCREEN:
            dispatch(onMouseOverUserPreferences());
            break;
        case ScreenControllerTypes.MY_SHOWS_OPTIONS_MENU_SCREEN:
            dispatch(onMouseOverMyShowsOptions());
            break;
        case ScreenControllerTypes.ONEPASS_AND_RECORDINGS_MENU_SCREEN:
            dispatch(onMouseOverOnePassAndRecordingsOptions());
            break;
        case ScreenControllerTypes.USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN:
            dispatch(onMouseOverAutoplayNextEpisode());
            break;
        case ScreenControllerTypes.USER_PREF_VIDEO_WINDOW_SCREEN:
            dispatch(onMouseOverUserPrefVideoWindowOperations());
            break;
        case ScreenControllerTypes.PROGRAM_SCREEN:
            dispatch(onMouseOverProgramScreen());
            break;
        case ScreenControllerTypes.VOD_BROWSE_MAIN_SCREEN:
            dispatch(onMouseOverVodBrowseMainScreen());
            break;
        case ScreenControllerTypes.MANAGE_SCREEN:
            dispatch(onMouseOverManage());
            break;
        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onMouseOverToDoList());
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onMouseOverRecordingActivity());
            break;
        default:
    }
};

export const onMouseWheel = (wheelDeltaY: number) => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;

    switch (screenController) {
        case ScreenControllerTypes.INFO_CARD_SCREEN:
            dispatch(onMouseWheelGlobalInfoCard(wheelDeltaY));
            break;

        case ScreenControllerTypes.GUIDE:
            dispatch(onMouseWheelGuide(wheelDeltaY));
            break;
        case ScreenControllerTypes.FILTERED_GUIDE_SCREEN:
            dispatch(onMouseWheelFilteredGuide(wheelDeltaY));
            break;
        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onMouseWheelVideoPlayerUi(wheelDeltaY));
            break;
        case ScreenControllerTypes.ONEPASS_MANAGER_SCREEN:
            dispatch(onMouseWheelOnePassManager(wheelDeltaY));
            break;
        case ScreenControllerTypes.MY_SHOWS_SCREEN:
            dispatch(onMouseWheelMyShows(wheelDeltaY));
            break;
        case ScreenControllerTypes.COLLECTION_SCREEN:
            dispatch(onMouseWheelCollectionScreen(wheelDeltaY));
            break;
        case ScreenControllerTypes.LIST_VIEW_SCREEN:
            dispatch(onMouseWheelListView(wheelDeltaY));
            break;
        case ScreenControllerTypes.TODO_LIST_SCREEN:
            dispatch(onMouseWheelToDoList(wheelDeltaY));
            break;
        case ScreenControllerTypes.RECORDING_ACTIVITY_SCREEN:
            dispatch(onMouseWheelRecordingActivity(wheelDeltaY));
            break;
        default:
    }
};

export default inputFactoryReducer;
